<doc>
  @desc:   缺省图
  @author:  
</doc>
<template>
  <div class="default-warp" :style="styles">
    <template v-if="$slots.default"><slot /></template>
    <template v-else>
      <img
        class="image"
        :style="imageStyles"
        src="~@/assets/images/icon-nodata.png"
      />
      <div class="text" :style="textStyles">{{ text }}</div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    // 最外层盒子样式
    styles: {
      type: Object,
      default() {
        return {
          color: "#b9bbce",
          padding: "40px 0",
          margin: "auto",
        };
      },
    },
    imageStyles: {
      type: Object,
      default() {
        return {
          width: "166px",
          height: "161px",
          margin: "0 auto 32px",
        };
      },
    },
    text: {
      type: String,
      default() {
        return this.langConfig.txtLang[this.langConfig.curLang]['NO_DATA'];
      },
    },
    textStyles: {
      type: Object,
      default() {
        return {
          color: "#b9bbce",
          "font-size": "18px",
          "text-align": "center",
        };
      },
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.default-warp {
  text-align: center;
  .image {
    display: block;
  }
  .text {
    font-family: @font_family_SF_Pro_Display;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/defaultPic.vue